<template>
   <Head>
      <title>{{ $t("meta.document_view.title") }}</title>
   </Head>
   <PageLoader :isLoading="isLoading" :loadErrors="loadErrors" :loadErrorMessage="loadErrorMessage">
      <div
         :id="`pdf-${docID}`"
         ref="document"
         class="w-full"
         style="height: calc(100vh - 5.5rem)"
         :data-cy="`pdf-${docID}`"
      ></div>
   </PageLoader>
</template>

<script setup lang="ts">
import { Head } from "@unhead/vue/components";
import { useRoute } from "vue-router";
import { useI18n } from "@/vue-i18n/vue-i18n";
import PDFObject from "pdfobject";
import { useApiRequest } from "@/composables/useApiRequest";
import DocumentsApi from "@/data/api-layer/documentsApi";

const { isLoading, execRequest, loadErrors } = useApiRequest();
const loadErrorMessage = ref<string>("");
const $route = useRoute();
const { t: $t } = useI18n();
const document = ref(null);
const state = reactive({
   docDataUrl: null,
});
const docID = $route.params.key as string;

// lifecycle
// -----------------------------------------
onMounted(async () => {
   const response = await execRequest(() => DocumentsApi.getDocument(docID));

   if (!response) {
      loadErrorMessage.value = $t("validation.pdf_fetch_error");
      return;
   }

   const downloadedBlob = new Blob([response.data], { type: "application/pdf" });
   state.docDataUrl = URL.createObjectURL(downloadedBlob);
});

onBeforeUnmount(() => {
   // let the browser know not to keep the reference to the file any longer.
   URL.revokeObjectURL(state.docDataUrl);
});

watchEffect(() => {
   if (document.value && state.docDataUrl) {
      embedPdf();
   }
});

// methods
// -----------------------------------------
function embedPdf() {
   PDFObject.embed(state.docDataUrl, `#pdf-${docID}`, {
      fallbackLink: `<p class="py-8 px-4">${$t("account.docs.no_inline_pdfs")} <a href="[url]" class="text-brand-dark underline">${$t(
         "account.docs.download"
      )}</a></p>`,
   });
}
</script>
